import { orderBy, where } from "firebase/firestore";
import { useMemo, useState } from "react";
import { Button, Card, Col, Form, ListGroupItem, Row } from "react-bootstrap";
import { CgOrganisation } from "react-icons/cg";
import { FaPlus } from "react-icons/fa";
import { Link, useNavigate } from "react-router";

import { useOrganizationCollection } from "../../api/firestoreWrappers.generated.jsx";
import {
    CorvusList,
    CorvusListItem,
    CorvusListItemText,
} from "../../components/CorvusList";
import Layout, { Title } from "../../components/Layout/Layout";
import SearchQueryInput from "../../components/SearchQueryInput/index.jsx";
import urls from "../../urls.jsx";

export default function OrganizationListPage() {
    const navigate = useNavigate();
    const [showDeletedOrganizations, setShowDeletedOrganizations] =
        useState(false);
    const [organizations] = useOrganizationCollection([
        where("deleted", "==", showDeletedOrganizations),
        orderBy("name", "asc"),
    ]);
    const [organizationQuery, setOrganizationQuery] = useState("");
    const filteredOrganizations = useMemo(() => {
        const q = organizationQuery.trim().toLowerCase();
        if (!q) return organizations;

        return organizations.filter((org) =>
            org.name.toLowerCase().includes(q),
        );
    }, [organizations, organizationQuery]);

    return (
        <Layout>
            <title>Organizations | MyCorvus</title>
            <Card>
                <Title title="Organizations">
                    <Button
                        variant="outline-success"
                        as={Link}
                        to={urls.organizationCreate()}
                    >
                        <FaPlus className="me-2" />
                        New Organization
                    </Button>
                </Title>
                <Form.Check
                    type="switch"
                    id="show-deleted"
                    label="Show deleted organizations"
                    checked={showDeletedOrganizations}
                    onChange={(e) =>
                        setShowDeletedOrganizations(e.target.checked)
                    }
                    className="ms-4"
                />
                <Row className="mb-3 mt-1 mx-2">
                    <Col>
                        <SearchQueryInput
                            placeholder={"Search organizations"}
                            onValueChange={(val) => setOrganizationQuery(val)}
                            onEnter={() => {
                                if (filteredOrganizations.length === 1) {
                                    navigate(
                                        urls.organization(
                                            filteredOrganizations[0].id,
                                        ),
                                    );
                                }
                            }}
                        />
                    </Col>
                </Row>
                <CorvusList>
                    {filteredOrganizations.length === 0 ? (
                        <ListGroupItem variant="warning" className="m-0">
                            <CgOrganisation className="me-2" />{" "}
                            <span className="fst-italic">
                                No organizations found
                            </span>
                        </ListGroupItem>
                    ) : (
                        filteredOrganizations.map((organization) => (
                            <CorvusListItem
                                className="p-0"
                                key={organization.id}
                                as={Link}
                                to={urls.organization(organization.id)}
                            >
                                <CorvusListItemText>
                                    {organization.name}
                                </CorvusListItemText>
                            </CorvusListItem>
                        ))
                    )}
                </CorvusList>
            </Card>
        </Layout>
    );
}
